<p-toast></p-toast>
<p-dialog
  header="System Information"
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '700px', maxWidth: '90vw'}"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false">

  <div class="version-container" *ngIf="!loading && versions">
    <!-- UI Version -->
    <div class="version-section">
      <h3><i class="pi pi-desktop"></i> Frontend (UI)</h3>
      <dl>
        <dt>Version:</dt>
        <dd class="version-value">{{ versions.ui.version }}</dd>

        <dt>Build ID:</dt>
        <dd>{{ versions.ui.buildId }}</dd>
      </dl>
    </div>

    <!-- API Version -->
    <div class="version-section">
      <h3><i class="pi pi-server"></i> Backend (API)</h3>
      <dl>
        <dt>Version:</dt>
        <dd class="version-value">{{ versions.api.version }}</dd>

        <dt>Build ID:</dt>
        <dd>{{ versions.api.buildId }}</dd>
      </dl>
    </div>
  </div>

  <!-- Loading State -->
  <div class="loading-container" *ngIf="loading">
    <p-progressSpinner styleClass="w-8 h-8"></p-progressSpinner>
    <p>Loading version information...</p>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <p-button
        label="Copy Info"
        icon="pi pi-copy"
        (onClick)="copyVersionInfo()"
        [disabled]="!versions"
        severity="secondary">
      </p-button>
      <p-button
        label="Close"
        icon="pi pi-times"
        (onClick)="visible = false">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
